<template>
    <div id="level-form">
        <v-card v-if="theme_type !== 'tryout'">
            <div class="px-1">
                <v-expansion-panels flat>
                    <v-expansion-panel
                        v-for="(data, i) in list_question"
                        :key="i"
                        class="mb-3"
                        style="border: 1.5px solid #f0f0f0; border-radius: 5px"
                    >
                        <v-expansion-panel-header class="font-weight-bold">
                            Nomor {{ data.sequence }}
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                            <div>
                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-500 pb-2 d-flex"
                                            style="
                                                align-items: center;
                                                justify-content: space-between;
                                            "
                                        >
                                            <div>Pertanyaan</div>
                                            <div>
                                                <v-btn
                                                    depressed
                                                    color="#e2f0f7"
                                                    class="primary--text"
                                                    x-small
                                                    height="40"
                                                    @click="editQuestion(data)"
                                                >
                                                    <v-icon
                                                        style="font-size: 20px"
                                                    >
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </v-list-item-title>
                                        <v-text-field
                                            placeholder="Ketik Pertanyaan"
                                            outlined
                                            disabled
                                            hide-details
                                            :value="data.question"
                                        />

                                        <div v-if="data.answers" class="py-3">
                                            <v-row
                                                v-for="(row, i) in data.answers"
                                                :key="i"
                                                class="pa-3 d-flex"
                                                style="align-items: center"
                                            >
                                                <v-col cols="1">
                                                    <v-btn
                                                        fab
                                                        small
                                                        depressed
                                                        color="#e8f5fa"
                                                        class="font-weight-bold primary--text"
                                                    >
                                                        {{
                                                            choice_alphabetical[
                                                                i
                                                            ]
                                                        }}
                                                    </v-btn>
                                                </v-col>
                                                <v-col
                                                    cols="8"
                                                    class="font-weight-500"
                                                >
                                                    {{ row.choice_sentence }}
                                                </v-col>
                                                <v-col
                                                    cols="2"
                                                    class="font-weight-bold"
                                                >
                                                    Kode : {{ row.value }}
                                                </v-col>
                                            </v-row>
                                        </div>

                                        <div align="right" class="py-3">
                                            <v-btn
                                                text
                                                @click="confirmDeleteItem(data)"
                                            >
                                                <v-icon
                                                    color="red"
                                                    small
                                                    class="mr-2"
                                                    >mdi-delete</v-icon
                                                >
                                                Hapus
                                            </v-btn>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-card v-if="!list_question.length" outlined>
                    <v-card-text>
                        <div align="center">Belum ada soal</div>
                    </v-card-text>
                </v-card>
            </div>

            <v-btn
                class="align-center text-body-2 blew white--text mt-5 ml-1"
                depressed
                @click="addQuestion()"
            >
                <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                Tambah Pertanyaan
            </v-btn>

            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                    @click="$emit('uncompleted', $attrs.data)"
                    depressed
                    text
                >
                    Kembali
                </v-btn>

                <v-btn
                    color="blew"
                    type="button"
                    class="btn btn-success pull-right"
                    @click="nextStep()"
                    depressed
                    dark
                >
                    Lanjutkan
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-else>
            <v-card-text class="pt-0">
                <div v-if="!selectedBundle.bundle_code">
                    <v-btn
                        block
                        depressed
                        color="lightblue"
                        class="primary--text"
                        @click="dialogSelectBundleSubtest = true"
                    >
                        <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                        Pilih Bundle Subtes
                    </v-btn>
                </div>

                <div v-if="selectedBundle.bundle_code">
                    <div
                        class="font-weight-600 mb-2 font-size-16 blacknew--text"
                    >
                        Bundle Subtes
                    </div>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th>Kode</th>
                                <th>Nama</th>
                                <th>Deskripsi</th>
                                <th width="140">Jumlah Soal</th>
                                <th width="180">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ selectedBundle.bundle_code }}</td>
                                <td>{{ selectedBundle.name }}</td>
                                <td>{{ selectedBundle.description }}</td>
                                <td>{{ selectedBundle.total_questions }}</td>
                                <td>
                                    <v-btn
                                        depressed
                                        small
                                        color="lightblue"
                                        class="blew--text mr-1"
                                        @click="detailBundle()"
                                    >
                                        Detail
                                    </v-btn>

                                    <v-btn
                                        depressed
                                        small
                                        color="lightred"
                                        class="red--text"
                                        @click="removeBundle()"
                                    >
                                        Hapus
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card-text>

            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                    @click="$emit('uncompleted', $attrs.data)"
                    depressed
                    text
                >
                    Kembali
                </v-btn>

                <v-btn
                    color="blew"
                    type="button"
                    class="pull-right white--text"
                    @click="nextStep()"
                    depressed
                    :disabled="!selectedBundle.bundle_code"
                >
                    Lanjutkan
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogQuestion" scrollable max-width="506px">
            <v-card>
                <v-card-title class="font-weight-bold darkgrey--text">
                    {{ question_id ? "Ubah" : "Tambah" }} Pertanyaan
                </v-card-title>

                <v-card-text>
                    <v-list-item two-line class="pa-0 mt-5">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                class="font-weight-500 darkgrey--text pb-2"
                            >
                                Pertanyaan
                            </v-list-item-title>
                            <v-text-field
                                v-model="data.question"
                                placeholder="Ketik Pertanyaan"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="detail_scale.question_type === 'choice'"
                        two-line
                        class="pa-0"
                    >
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                class="font-weight-500 darkgrey--text pb-2"
                            >
                                Jawaban
                            </v-list-item-title>

                            <v-row
                                v-for="(row, i) in answer_choice"
                                :key="i"
                                class="pa-3 d-flex"
                                style="align-items: center"
                            >
                                <v-col cols="1">
                                    <v-btn
                                        fab
                                        small
                                        depressed
                                        color="#e8f5fa"
                                        class="font-weight-bold primary--text"
                                    >
                                        {{ row.choice_alphabetical }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="row.choice_sentence"
                                        placeholder="Ketik Jawaban"
                                        outlined
                                        class="ml-4"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-select
                                        v-model="row.value"
                                        :items="value_answer"
                                        placeholder="Kode"
                                        outlined
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>

                <v-card-actions class="pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogQuestion = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        depressed
                        dark
                        :loading="isLoading"
                        @click="submit()"
                    >
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" persistent max-width="480px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    Apakah anda akan menghapus soal ini ?
                </v-card-title>
                <v-card-text>
                    soal
                    <b>{{ selectedRow ? selectedRow.question : "" }}</b> akan
                    dihapus.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="red"
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="deleteItem()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogSelectBundleSubtest"
            persistent
            scrollable
            max-width="900px"
        >
            <dialog-bundle
                @select="onSelectedBundle($event)"
                @close="dialogSelectBundleSubtest = false"
            />
        </v-dialog>

        <v-dialog
            v-model="dialogDetailBundle"
            persistent
            max-width="900px"
            scrollable
        >
            <dialog-detail-bundle
                v-if="dialogDetailBundle"
                :bundle-code="selectedBundle.bundle_code"
                @close="dialogDetailBundle = false"
            />
        </v-dialog>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import ambis_test from "../services/ambis_test";
import DialogSelectBundleSubtest from "./DialogSelectBundleSubtest.vue";
import DialogDetailBundle from "./DialogDetailBundle.vue";

export default {
    name: "question-form",

    components: {
        "app-spinner": Spinner,
        "dialog-bundle": DialogSelectBundleSubtest,
        "dialog-detail-bundle": DialogDetailBundle,
    },

    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            selectedRow: null,
            confirmDialog: false,
            dialogQuestion: false,
            dialogSelectBundleSubtest: false,
            dialogDetailBundle: false,
            errors: [],
            show: true,
            list_question: [],
            data: {
                sequence: 1,
                question: "",
                answers: [],
            },
            question_id: "",
            expanded: [],
            choice_alphabetical: [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
            ],
            detail_scale: {},
            answer_choice: [],
            value_answer: [],
            bundles: [],
            selectedBundle: {},
            scale: {
                theme_id: null,
                scale_name: null,
                scale_level: [],
                scale_description: null,
                processing_time: null,
                norm: null,
                status: "draft",
                type: null,
                scale_type: "FREE",
                max_answer: 0,
                set_value_answer: "",
                scale_picture: null,
                intro_name: null,
                intro_description: null,
                user_group: [],
                test_tryout_id: null,
            },
            theme: {},
            theme_type: null,
        };
    },

    computed: {
        // answer_choice() {
        //       const data = [];
        // for (var a = 0; a <= 5; a++) {
        //   var sequence = a + 1;
        //   data.push({
        //     choice_alphabetical: this.choice_alphabetical[a],
        //     choice_sequence: sequence,
        //     choice_sentence: "",
        //     value: "",
        //   });
        // }
        // return data;
        // },
    },

    mounted() {
        this.getListQuestion();
        this.getDetailScale();
        this.getDetailTheme();
    },

    methods: {
        getAnswerChoice() {
            const data = [];
            const value = this.detail_scale.value_answer.split(";");
            const max_answer = this.detail_scale.max_answer || 0;

            for (var a = 0; a < max_answer; a++) {
                var sequence = a + 1;

                data.push({
                    choice_alphabetical: this.choice_alphabetical[a],
                    choice_sequence: sequence,
                    choice_sentence: "",
                    value: value[a],
                });
            }

            this.answer_choice = data;
        },

        addQuestion() {
            this.dialogQuestion = true;
            this.getAnswerChoice();
            this.clearForm();
        },

        editQuestion(val) {
            this.dialogQuestion = true;
            this.question_id = val.question_id;
            this.getDetailQuestion();
        },

        toggleExpand(index) {
            7;
            this.$set(this.expanded, index, !this.expanded[index]);
        },

        getListQuestion() {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.getListQuestion(scale_id, function (result) {
                if (result) {
                    context.list_question = result.data;
                }
            });
        },

        getDetailQuestion() {
            var context = this;

            ambis_test.detailQuestion(context.question_id, function (result) {
                if (result.success) {
                    const datail_question = result.data;

                    context.data = {
                        sequence: datail_question.sequence,
                        question: datail_question.question,
                    };

                    if (datail_question.answers) {
                        const answer_choice_arr = datail_question.answers.map(
                            (e, i) => {
                                e.answer_id = e.answer_id;
                                e.choice_alphabetical =
                                    context.choice_alphabetical[i];
                                return e;
                            }
                        );

                        context.answer_choice = answer_choice_arr;
                    } else {
                        context.getAnswerChoice();
                    }
                }
            });
        },

        // getDetailScale() {
        //     var context = this;
        //     const scale_id =
        //         context.$route.query.scale_id || context.$attrs.data.id;

        //     ambis_test.getDetailScale(scale_id, function (result) {
        //         if (result.success) {
        //             context.detail_scale = result.data;
        //             context.value_answer = result.data.value_answer.split(";");
        //             context.getAnswerChoice();
        //         }
        //     });
        // },

        submit: function () {
            var context = this;
            const question_id = context.question_id;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            context.data.answers =
                context.detail_scale.question_type === "choice"
                    ? context.answer_choice
                    : [];

            if (this.validateForm()) {
                context.isLoading = true;

                if (scale_id && question_id) {
                    ambis_test.editQuestion(
                        question_id,
                        scale_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });

                                context.dialogQuestion = false;
                                context.getListQuestion();
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal Menyimpan Data!`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        }
                    );
                } else {
                    ambis_test.addQuestion(
                        scale_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });

                                context.dialogQuestion = false;
                                context.getListQuestion();
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal Menyimpan Data!`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        }
                    );
                }
            }
        },

        validateForm: function () {
            var err = false;
            if (!this.data.question) {
                this.$store.commit("showAlert", {
                    message: `Pertanyaan wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            // Check duplication value answer (if choice question type)
            if (this.detail_scale.question_type === "choice") {
                let obj = this.answer_choice;
                const checkedValues = {};

                // Melintasi setiap objek dalam array answers
                for (const answer of obj) {
                    // Memeriksa apakah nilai value sudah pernah diperiksa sebelumnya
                    if (checkedValues[answer.value]) {
                        this.$store.commit("showAlert", {
                            message: `Value choice tidak boleh sama!`,
                            type: "error",
                        });
                        err = true;
                    } else {
                        // Menyimpan nilai value ke dalam objek checkedValues
                        checkedValues[answer.value] = true;
                    }
                }
            }

            return !err;
        },

        clearForm() {
            this.question_id = "";
            this.data.question = "";
        },

        nextStep() {
            this.$emit("completed", this.scale);
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteItem() {
            var context = this;
            const id = context.selectedRow.question_id;

            context.isLoadingForm = true;

            ambis_test.deleteQuestion(id, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.getListQuestion();
                    context.isLoadingForm = false;
                } else {
                    context.isLoadingForm = false;
                    context.$store.commit("showAlert", {
                        message: `Gagal Menghapus Data!`,
                        type: "error",
                    });
                }
            });
        },

        onSelectedBundle(data) {
            this.dialogSelectBundleSubtest = false;
            this.selectedBundle = data;

            const bundle_id = this.selectedBundle.test_id;
            this.updateScaleBundleSubtes(bundle_id);
        },

        removeBundle() {
            this.selectedBundle = {};
            const bundle_id = "";

            this.updateScaleBundleSubtes(bundle_id);
        },

        detailBundle() {
            this.dialogDetailBundle = true;
        },

        getDetailScale() {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.getDetailScale(scale_id, function (result) {
                if (result.success) {
                    const data = result.data;
                    let scale_level = data.scale_level || "";
                    let scale_level_arr = scale_level.split(",");

                    context.scale = {
                        theme_id: context.$route.query.theme_id,
                        scale_name: data.scale_name,
                        scale_level: scale_level_arr,
                        scale_description: data.scale_description,
                        processing_time: data.processing_time,
                        norm: "",
                        status: data.status,
                        type: data.question_type,
                        scale_type: data.scale_type,
                        max_answer: data.max_answer,
                        set_value_answer: data.value_answer,
                        scale_picture: null,
                        intro_name: data.intro_name,
                        intro_description: data.intro_description,
                        test_tryout_id: data.test_tryout_id,
                    };

                    context.detail_scale = result.data;
                    context.value_answer = result.data.value_answer.split(";");

                    context.scale.user_group = data.user_group.map(
                        (group) => group.id
                    );

                    context.getDetailBundle();
                }
            });
        },

        updateScaleBundleSubtes(bundle_id) {
            var context = this;
            context.scale.test_tryout_id = bundle_id;
            context.scale.max_answer = context.selectedBundle.total_questions;

            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.editScale(scale_id, context.scale, function (result) {
                if (!result.success) {
                    context.$store.commit("showAlert", {
                        message: `Tidak dapat memilih bundle test, terjadi kesalahan saat menambahkan skala`,
                        type: "error",
                    });

                    context.selectedBundle = {};
                    context.scale = result.data;
                }
                context.isLoading = false;
            });
        },

        getDetailBundle() {
            var context = this;
            const bundle_id = context.scale.test_tryout_id;

            ambis_test.getDetailBundle(bundle_id, function (result) {
                if (result.success) {
                    context.selectedBundle = result.data;
                }
            });
        },

        getDetailTheme() {
            var context = this;
            const theme_id = context.$route.query.theme_id;

            ambis_test.getDetailTheme(theme_id, function (result) {
                if (result.success) {
                    context.theme = result.data;
                    context.theme_type = result.data.type;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// QuestionForm.vue?2fffd4c4